import React from 'react'

const Loading = props => {
  return (
    <section className="modal loading-modal">
      <div className="loading">
        <h2 className="sub-heading">{props.loadingMessage}</h2>
        <img src="/images/wave.svg" alt="loading animation" />
      </div>
    </section>
  );
}

export function Spinner() {
  return (
    <svg className="spinner">
      <circle cx="10" cy="10" r="9" viewBox="0 0 25 25" x="0" y="0"></circle>
    </svg>
  )
}

export default Loading;